import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import {
    selectSpeakerSearchData,
    selectSpeakerSearchStatus,
    selectSpeakerSearchError,
    initializeAsync,
    createSpeakerListAsync,
    addSpeakerToListAsync,
    removeSpeakerFromListAsync,
    updateSpeakerListAsync,
    saveNotesAsync,
    getCommentsAsync,
    getNotesAsync,
    getSpeakerDetailsAsync,
    createSpeakerList2Async,
    fetchSpeakersCommentsAsync,
} from "./speakerSearchSlice";

import {
    Button,
    Box,
    MenuItem,
    TextField,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Chip,
    FormControlLabel,
    Autocomplete,
    FormControl,
    InputLabel,
    Select,
    Typography,
    Drawer,
    Divider,
    SwipeableDrawer,
    List,
    ListItem,
    ListItemButton,
    ListItemAvatar,
    Avatar,
    ListItemText,
    useMediaQuery,
    useTheme,
    Grid as MUIGrid,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Grid from "@mui/material/Unstable_Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { config, styles } from "../../style";
import { SpeakerCard } from "./speakerCard";

import "instantsearch.css/themes/reset.css";
// or include the full Satellite theme
import "instantsearch.css/themes/satellite.css";
import "./style.css";
import { describe } from "../../services/salesforce";
import { format } from "date-fns";

// Add custom imports here

import algoliasearch from "algoliasearch/lite";
import {
    InstantSearch,
    SearchBox,
    ClearRefinements,
    RefinementList,
    Pagination,
    useInfiniteHits,
    useStats,
    useRefinementList,
    Highlight,
    Configure,
    useMenu,
    useClearRefinements,
    useCurrentRefinements,
    useInstantSearch,
} from "react-instantsearch-hooks-web";
import { Filter } from "./filter";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DateRangeIcon from "@mui/icons-material/DateRange";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { Modal } from "../../components/Modal";
import { useAuth } from "../../hooks/useAuth";
import { AlertDialog } from "../../components/AlertDialog";
import { Speaker } from "../Speaker";
import { DeleteOutline as DeleteOutlineIcon, FilterAlt } from "@mui/icons-material";
import Modal2 from "../../components/Modal/Modal2";
import MyList from "./MyList";
import { ProposalIcon } from "../../icons/proposal-icon";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { use } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const searchClient = algoliasearch(process.env.REACT_APP_ALGOLIA_APPLICATION_ID, process.env.REACT_APP_ALGOLIA_API_KEY);

let allCount = 0;

const FILTERS_NAME_LIST = [
    {
        attribute: "mainCategory",
        label: "Topics & Types",
    },
    {
        attribute: "speakerStatus",
        label: "Speaker Status",
    },
    {
        attribute: "feeCode",
        label: "Budget",
    },
    {
        attribute: "regionFeeName",
        label: "Fee Region",
    },
    {
        attribute: "regionFeeValue",
        label: "Budget",
    },
    {
        attribute: "speakerHomeCountry",
        label: "Country",
    },
    {
        attribute: "speakerHomeState",
        label: "State",
    },
    {
        attribute: "speakerHomeCity",
        label: "City",
    },
];

const InfiniteHits = (props) => {
    const { filter, setIsLoading, isLoading } = props;
    const params = {
        speakerLists: props.speakerLists,
        listBySpeaker: props.listBySpeaker,
        commentBySpeaker: props.commentBySpeaker,
        noteBySpeaker: props.noteBySpeaker,
        countryPicklist: props.countryPicklist,
        filter,
    };
    const data = useSelector(selectSpeakerSearchData);
    const dispatch = useDispatch();
    const {
        hits,
        items,
        currentPageHits,
        results,
        banner,
        isFirstPage,
        isLastPage,
        showPrevious,
        showMore,
        sendEvent,
    } = useInfiniteHits(params);
    const { refresh } = useInstantSearch();
    const { items: filterItems, refine } = useCurrentRefinements();

    const theme = useTheme();

    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    let isBureau = userDetails.contact.clientType === "Bureau";

    const [commentsList, setCommentsList] = useState([]);

    const sentinelRef = useRef(null);

    useEffect(() => {
        refresh(); // Trigger a refresh after the filter changes
    }, [filter, refresh]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !isLastPage) {
                        showMore();
                    }
                });
            },
            {
                ...(isMobileScreen
                    ? {}
                    : {
                          root: document.querySelector(".scroll-container"),
                      }),

                threshold: 1,
            }
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [isLastPage, showMore, isMobileScreen]);

    useEffect(() => {
        let speakerIds = [];
        if (data.speakerComments) {
            for (let hit of hits) {
                if (!data.speakerComments[hit.Id]) {
                    speakerIds.push(hit.Id);
                }
            }
        } else {
            speakerIds = hits.map((hit) => hit.Id);
        }
        if (speakerIds.length > 0) {
            dispatch(fetchSpeakersCommentsAsync({ speakerIds, accountId: userDetails.contact.accountId }));
        }

        if (hits?.length > 0) {
            setIsLoading(false);
        }
    }, [hits]);

    return (
        <div
            className="scroll-container"
            style={{
                height: `100%`,
                // paddingRight:"0.5rem",
                paddingBottom: "0.5rem",
                overflow: "auto",
            }}>
            {!isLoading && (
                <>
                    {hits.length === 0 ? (
                        <Box sx={{ p: "1rem 0px" }}>
                            <Card
                                sx={{
                                    ...styles.card,
                                    mt: "15px",
                                    backgroundColor: "white",
                                }}>
                                <CardContent sx={{ p: "15px 15px" }}>No speaker found</CardContent>
                            </Card>
                        </Box>
                    ) : (
                        <>
                            {hits.map((hit) => (
                                <SpeakerCard
                                    key={hit.Id}
                                    record={hit}
                                    speakerLists={props.speakerLists}
                                    listBySpeaker={props.listBySpeaker}
                                    commentBySpeaker={props.commentBySpeaker}
                                    noteBySpeaker={props.noteBySpeaker}
                                    availabilityCheck={props.availabilityCheck}
                                    availabilityCheckStart={props.availabilityCheckStart}
                                    availabilityCheckEnd={props.availabilityCheckEnd}
                                    commentsList={commentsList}
                                    setCommentsList={setCommentsList}
                                    isBureau={isBureau}
                                    countryPicklist={props.countryPicklist}
                                    filterItems={filterItems || []}></SpeakerCard>
                            ))}
                            <div id="sentinelRef" ref={sentinelRef}></div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

const Stats = (props) => {
    const { hitsPerPage, nbHits, areHitsSorted, nbSortedHits, nbPages, page, processingTimeMS, query } =
        useStats(props);

    if (allCount === 0 && nbHits > 0) {
        allCount = nbHits;
    }

    const getCounts = () => {
        if (props.selectedSpeakerList) {
            return allCount;
        }
        return nbHits;
    };

    return (
        <CardHeader
            sx={{
                padding: "15px",

                "& .MuiCardHeader-action": {
                    margin: 0,
                },
            }}
            title={
                <Grid
                    container
                    sx={{
                        border: "1px solid #E0EAFF",
                        ml: "10px",
                        background: "#E0EAFF",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "3px 8px",
                        fontSize: "16px",
                        fontWeight: "400",
                    }}>
                    <Grid item sx={{ p: "0", color: "#2D3282" }}>
                        {"All Speakers"}: {getCounts()}
                    </Grid>
                </Grid>
            }
        />
    );
};

const CustomRefinementList = (props) => {
    const {
        items,
        hasExhaustiveItems,
        createURL,
        refine,
        sendEvent,
        searchForItems,
        isFromSearch,
        canRefine,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore,
    } = useRefinementList(props);

    const [searchText, setSearchText] = useState("");
    const [showAll, setShowAll] = useState(false);

    const location = useLocation();

    // console.log('location.state...',location.state);

    if (location.state?.selectedTopics?.length > 0 && props.attribute === "mainCategory" && items.length === 0) {
        location.state.selectedTopics.forEach((value) => {
            refine(value.name);
        });
    }

    useEffect(() => {
        if (location.state?.selectedTopics?.length > 0 && props.attribute === "mainCategory") {
            location.state.selectedTopics.forEach((value) => {
                const createEvent = new CustomEvent("filterChange", {
                    detail: {
                        value: true,
                    },
                });
                document.dispatchEvent(createEvent);
            });
        }
    }, []);

    useEffect(() => {
        toggleShowMore();
    }, [toggleShowMore]);

    const getItems = () => {
        let records = items;
        if (searchText) {
            records = records.filter((item) => item.label.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
        }
        return showAll ? records : records.slice(0, 10);
    };

    const handleSelect = (event, currentSelectedItem) => {
        // uncheck all other items and select selected one
        const allRefinedItems = items.filter((cItem) => cItem.isRefined);
        allRefinedItems.forEach((cItem) => {
            if (currentSelectedItem === cItem.value) {
                return;
            }

            refine(cItem.value);
            const createEvent = new CustomEvent("filterChange", {
                detail: {
                    value: false,
                },
            });
            document.dispatchEvent(createEvent);
        });

        handleChange(event, currentSelectedItem);
    };

    //  props.attribute==="regionFeeName"&&console.log("Fee Region",{items});
    //  props.attribute==="regionFeeValue"&&console.log("Budget",{items});

    const handleChange = (event, value) => {
        refine(value);
        const createEvent = new CustomEvent("filterChange", {
            detail: {
                value: event.target.checked,
            },
        });
        document.dispatchEvent(createEvent);
    };

    return (
        <Box className="RefinementList">
            {props.searchable && (
                <TextField
                    sx={{ mb: "10px" }}
                    fullWidth
                    variant="outlined"
                    id="input-with-icon-textfield"
                    label=""
                    placeholder="Search by keyword"
                    onChange={(event) => {
                        setSearchText(event.currentTarget.value);
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            )}
            {getItems().length > 0 &&
                getItems().map((item) => (
                    <Box key={item.label} sx={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
                        <FormControlLabel
                            className={item.isRefined ? "selected" : ""}
                            control={
                                <Checkbox
                                    value={item.value}
                                    checked={item.isRefined}
                                    onChange={(event) => {
                                        if (props.attribute === "regionFeeName") {
                                            handleSelect(event, event.currentTarget.value);
                                        } else {
                                            handleChange(event, event.currentTarget.value);
                                        }
                                    }}
                                />
                            }
                            label={item.label}
                        />
                        <Chip sx={{ fontSize: "12px", height: "25px" }} label={item.count} />
                    </Box>
                ))}
            {getItems().length === 0 && <span>No filter</span>}
            {getItems().length === 10 && getItems().length < items.length && (
                <Button variant="text" onClick={() => setShowAll(true)}>
                    Show more
                </Button>
            )}
            {getItems().length > 10 && getItems().length === items.length && (
                <Button variant="text" onClick={() => setShowAll(false)}>
                    Show less
                </Button>
            )}
        </Box>
    );
};

const CustomMenu = (props) => {
    const { items, createURL, refine, canRefine, isShowingMore, toggleShowMore, canToggleShowMore, sendEvent } =
        useMenu(props);

    const { refine: feeRefine } = useMenu({ attribute: "regionWithFeeValue" });

    const { items: filterItems } = useCurrentRefinements();

    const [searchText, setSearchText] = useState("");
    const [showAll, setShowAll] = useState(false);
    const [currentValue, setCurrentValue] = useState(null);

    useEffect(() => {
        toggleShowMore();
    }, [toggleShowMore]);

    const handleChange = (event, value) => {
        if (filterItems?.length > 0 || value) {
            const hasRegionFeeName =
                filterItems?.find((c) => c.attribute === "regionFeeName") ||
                (value && props.attribute === "regionFeeName");
            const hasRegionFeeValue =
                filterItems?.find((c) => c.attribute === "regionFeeValue") ||
                (value && props.attribute === "regionFeeValue");
            if (hasRegionFeeName && hasRegionFeeValue) {
                let regionFeeName = filterItems?.find((c) => c.attribute === "regionFeeName");
                let regionFeeValue = filterItems?.find((c) => c.attribute === "regionFeeValue");
                let feeValue = regionFeeValue?.refinements[0]?.value || value;
                let feeName = regionFeeName?.refinements[0]?.value || value;
                if (feeName && feeValue) {
                    refine(value ? value : "");
                    feeRefine(feeName + " - " + feeValue);
                    setCurrentValue(value);
                }
            } else {
                refine(value ? value : "");
                setCurrentValue(value);
            }

            // increasing number of selected items
            if (value) {
                if (!currentValue) {
                    const createEvent = new CustomEvent("filterChange", {
                        detail: {
                            value: value,
                        },
                    });
                    document.dispatchEvent(createEvent);
                }
            } else {
                const createEvent = new CustomEvent("filterChange", {
                    detail: {
                        value: value,
                    },
                });
                document.dispatchEvent(createEvent);
            }
        }
    };

    useEffect(() => {
        if (filterItems?.length <= 0) {
            setCurrentValue(null);
            return;
        }
        // when close/delete button clicked on ShowAppliedFiltersUI filters
        // then filterItems changes, if filter items not contain that particular filter set null value
        // and if no filters present set null value for all attribures also
        if (props.attribute === "speakerHomeCountry") {
            const index = filterItems?.findIndex((c) => c.attribute === "speakerHomeCountry");
            if (index === -1) {
                setCurrentValue(null);
                return;
            }
        }

        if (props.attribute === "speakerHomeState") {
            const index = filterItems?.findIndex((c) => c.attribute === "speakerHomeState");
            if (index === -1) {
                setCurrentValue(null);
                return;
            }
        }

        if (props.attribute === "speakerHomeCity") {
            const index = filterItems?.findIndex((c) => c.attribute === "speakerHomeCity");
            if (index === -1) {
                setCurrentValue(null);
                return;
            }
        }

        if (props.attribute === "regionFeeName") {
            const index = filterItems?.findIndex((c) => c.attribute === "regionFeeName");
            if (index === -1) {
                setCurrentValue(null);
                return;
            }
        }
        if (props.attribute === "regionFeeValue") {
            const index = filterItems?.findIndex((c) => c.attribute === "regionFeeValue");
            if (index === -1) {
                setCurrentValue(null);
                return;
            }
        }
    }, [filterItems]);

    const getFeeOptions = () => {
        let feeOptions = [
            "$0 - $20,000",
            "$20,001 - $40,000",
            "$40,001 - $60,000",
            "$60,001 - $80,000",
            "$80,001 - $100,000",
            "$100,001 - $120,000",
            "$120,001 - $140,000",
            "$140,001 - $160,000",
            "$160,001 - $180,000",
            "$180,001 - $200,000",
            "$200,001 & Up",
        ];

        return feeOptions;
    };

    return (
        <Box className="CustomMenu">
            <Autocomplete
                disablePortal
                fullWidth
                id="combo-box-demo"
                sx={{ mt: ".5rem" }}
                value={currentValue}
                options={props.attribute === "regionFeeValue" ? getFeeOptions() : items.map((item) => item.label)}
                onChange={(event, value) => handleChange(event, value)}
                renderInput={(params) => <TextField fullWidth {...params} label={props.label} />}
            />
        </Box>
    );
};

const CustomClearRefinements = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        clearFilter() {
            handleClick();
        },
    }));

    const data = useClearRefinements({});

    const handleClick = () => {
        data.refine();
        const createEvent = new CustomEvent("clearFilter");
        document.dispatchEvent(createEvent);
    };

    return (
        <>
            <Box sx={{ mt: "5.5px" }}>
                <Grid
                    container
                    sx={{
                        border: "1px solid #E0EAFF",
                        mr: "10px",
                        background: "#E0EAFF",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        height: "38px",
                    }}>
                    <Grid item sx={{ p: "0px", color: "#2D3282", marginTop: "-6px" }}>
                        {props.filterCount} selected
                    </Grid>
                    <Grid item sx={{ p: "0px", cursor: "pointer" }}>
                        <CloseIcon
                            fontSize="small"
                            sx={{ ml: "10px", color: "#6172F3" }}
                            onClick={handleClick}></CloseIcon>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
});

const ShowAppliedFiltersUI = ({ setUpperBoxHeight }) => {
    const { items: filterItems, refine } = useCurrentRefinements();

    const ref = useRef();

    const handleDelete = (value) => {
        refine(value);

        const createEvent = new CustomEvent("filterChange", {
            detail: {
                value: false,
            },
        });
        document.dispatchEvent(createEvent);
    };
    useEffect(() => {
        if (filterItems?.length) {
            setUpperBoxHeight((prevState) => ({
                ...prevState,
                h2: ref?.current?.offsetHeight ? ref?.current?.offsetHeight + 16 : 0,
            }));
        } else {
            setUpperBoxHeight((prevState) => ({
                ...prevState,
                h2: 0,
            }));
        }
    }, [filterItems?.length]);

    if (filterItems?.filter((item) => item.attribute !== "regionWithFeeValue").length <= 0) {
        return <></>;
    }

    return (
        <Box ref={ref}>
            <Card sx={{ ...styles.card, mb: "1rem", padding: "1rem" }}>
                <MUIGrid container spacing={0.5}>
                    {filterItems
                        ?.filter((item) => item.attribute !== "regionWithFeeValue")
                        ?.map((cFilterItem, index) => {
                            const filterCatagory = FILTERS_NAME_LIST.find(
                                (cName) => cName.attribute === cFilterItem.attribute
                            );

                            return (
                                <>
                                    <MUIGrid
                                        item
                                        container
                                        spacing={1}
                                        sx={{
                                            // border: "1px solid",
                                            width: "fit-content",
                                            alignItems: "center",
                                        }}>
                                        <Box
                                            component={MUIGrid}
                                            // item
                                            container
                                            spacing={1}
                                            sx={{
                                                border: "1px solid #bdbdbd",
                                                borderRadius: "1rem",

                                                padding: "0.5rem",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                margin: "0.5rem",

                                                paddingTop: 0,
                                                paddingLeft: 0,

                                                position: "relative",

                                                "&::before": {
                                                    content: `"${filterCatagory?.label}"`,
                                                    position: "absolute",
                                                    top: "-10px",
                                                    left: "10px",
                                                    // transform: "translateX(-20px)",
                                                    padding: "0 4px",
                                                    fontSize: "12px",
                                                    // fontWeight: "bold",
                                                    background: "#fff",

                                                    maxWidth: "80%", // Adjusts based on container width
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                },
                                            }}>
                                            {cFilterItem.refinements.map((cRefine, index) => {
                                                return (
                                                    <>
                                                        <MUIGrid
                                                            item
                                                            sx={
                                                                {
                                                                    // border: "1px solid",
                                                                }
                                                            }>
                                                            <Chip
                                                                label={cRefine.label}
                                                                variant="outlined"
                                                                onDelete={() => {
                                                                    handleDelete(cRefine);
                                                                }}
                                                            />
                                                        </MUIGrid>
                                                    </>
                                                );
                                            })}
                                        </Box>
                                    </MUIGrid>
                                </>
                            );
                        })}
                </MUIGrid>
            </Card>
        </Box>
    );
};

const SpeakerSearch = ({ application }) => {
    const data = useSelector(selectSpeakerSearchData);
    const status = useSelector(selectSpeakerSearchStatus);
    const error = useSelector(selectSpeakerSearchError);
    const dispatch = useDispatch();

    const [availabilityCheck, setAvailabilityCheck] = useState(undefined);
    const [availabilityCheckStart, setAvailabilityCheckStart] = useState(undefined);
    const [availabilityCheckEnd, setAvailabilityCheckEnd] = useState(undefined);

    const [openCreateListModal, setOpenCreateListModal] = useState(false);
    const [currentCreateRecord, setCurrentCreateRecord] = useState(undefined);
    const [currentListRecord, setCurrentListRecord] = useState(undefined);
    const [filterCount, setFilterCount] = useState(0);
    const [selectedSpeakerList, setSelectedSpeakerList] = useState(undefined);
    const [selectedMemberToDelete, setSelectedMemberToDelete] = useState(undefined);
    const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState(false);
    const [openLeaveNoteModal, setOpenLeaveNoteModal] = useState(false);
    const [currentNote, setCurrentNote] = useState(undefined);
    const [openRequestProposalModal, setOpenRequestProposalModal] = useState(false);
    const [countryPicklist, setCountryPicklist] = useState([]);
    const [endDateTimePicklist, setEndDateTimePicklist] = useState([]);
    const [startDateTimePicklist, setStartDateTimePicklist] = useState([]);
    const [openSpeakerScreen, setOpenSpeakerScreen] = useState(false);
    const [selectedSpeakerForViewProfile, setSelectedSpeakerForViewProfile] = useState({});
    const [memberListToDelete, setMemberListToDelete] = useState([]);
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
    const [isEventDateAdded, setIsEventDateAdded] = useState(false);
    const [upperBoxHeight, setUpperBoxHeight] = useState({
        h1: 68,
        h2: 0,
        h3: 0,
    });
    const [showError, setShowError] = useState("");

    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [isLoading, setIsLoading] = useState(true);

    let isBureau = userDetails.contact.clientType === "Bureau";
    const customClearRefinementsRef = useRef(null);
    const searchRef = useRef(null);
    const search2Ref = useRef(null);
    const upperBoxRef = useRef(null);
    const upperBoxRef2 = useRef(null);
    const [openListDeleteConfirmationModal, setOpenListDeleteConfirmationModal] = useState(false);

    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.addEventListener("create", handleCreate);
        document.addEventListener("addSpeaker", handleAddSpeaker);
        document.addEventListener("filterChange", handleFilterChange);
        document.addEventListener("clearFilter", handleClearFilter);
        document.addEventListener("removeSpeaker", handleRemoveFilter);
        document.addEventListener("leaveNote", handleLeaveNote);
        document.addEventListener("requestProposal", handleRequestProposal);
        document.addEventListener("viewProfile", handleViewProfile);
        document.addEventListener("closeSpeakerDrawer", handleCloseSpeakerDrawer);

        if (status === "idle") {
            dispatch(
                initializeAsync({
                    contactId: userDetails?.contact?.id,
                    application,
                    accountId: userDetails?.contact?.accountId,
                })
            );
            dispatch(
                getCommentsAsync({
                    contactId: userDetails?.contact?.id,
                    application,
                    accountId: userDetails?.contact?.accountId,
                })
            );

            // getCalendarEntryDescribe();
        }
        return () => {
            document.removeEventListener("create", handleCreate);
            document.removeEventListener("filterChange", handleFilterChange);
            document.removeEventListener("clearFilter", handleClearFilter);
            document.removeEventListener("addSpeaker", handleAddSpeaker);
            document.removeEventListener("removeSpeaker", handleRemoveFilter);
            document.removeEventListener("leaveNote", handleLeaveNote);
            document.removeEventListener("requestProposal", handleRequestProposal);
            document.removeEventListener("viewProfile", handleViewProfile);
            document.addEventListener("closeSpeakerDrawer", handleCloseSpeakerDrawer);
        };
    }, [status, dispatch, userDetails, filterCount]);

    useEffect(() => {
        if (selectedSpeakerList?.status) {
            setUpperBoxHeight((prevState) => ({
                ...prevState,
                h3: upperBoxRef2?.current?.offsetHeight ? upperBoxRef2?.current?.offsetHeight + 16 : 0,
            }));
        } else {
            setUpperBoxHeight((prevState) => ({
                ...prevState,
                h3: 0,
            }));
        }
    }, [selectedSpeakerList?.status]);

    useEffect(() => {
        getCalendarEntryDescribe();
    }, []);

    useEffect(() => {
        // beforeunload doing location state null
        // console.log("running");

        const handleBeforeUnload = (event) => {
            if (location.state?.selectedTopics?.length > 0) {
                console.log("Page is about to refresh or unload");
                navigate("/speaker-search");
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const getCalendarEntryDescribe = async () => {
        const result = await describe("calendarEntry", { cacheable: true });
        if (result.isSuccess) {
            // console.log(result);
            for (let field of result?.data?.fields) {
                if (field.name === "Location_Country_Global__c") {
                    setCountryPicklist(field.picklistValues);
                } else if (field.name === "End_Date_Time__c") {
                    setEndDateTimePicklist(field.picklistValues);
                } else if (field.name === "Start_Date_Time__c") {
                    setStartDateTimePicklist(field.picklistValues);
                }
            }
        }
    };

    const handleCloseSpeakerDrawer = () => {
        setOpenSpeakerScreen(false);
    };

    const handleViewProfile = async (event) => {
        let speakerRecord = event.detail.value;
        if (data?.speakerDetails && data?.speakerDetails[speakerRecord.Id]) {
            setSelectedSpeakerForViewProfile(data?.speakerDetails[speakerRecord.Id]);
            setOpenSpeakerScreen(true);
        } else {
            dispatch(
                getSpeakerDetailsAsync({
                    id: speakerRecord.Id,
                    callback: (result) => {
                        if (result.isSuccess && result.data.length > 0) {
                            setSelectedSpeakerForViewProfile(result.data[0]);
                            setOpenSpeakerScreen(true);
                        }
                    },
                })
            );
        }
    };

    const handleCreate = (event) => {
        const detail = event?.detail;
        setCurrentCreateRecord(detail?.value);
        setCurrentListRecord({ isPrivate: true, type: "Private" });
        setOpenCreateListModal(true);
        setMemberListToDelete([]);
    };

    const handleEditList = (item) => {
        setCurrentListRecord({ ...item });
        setOpenCreateListModal(true);
        setMemberListToDelete([]);
    };

    const handleCreateListModalClose = () => {
        setOpenCreateListModal(false);
        //setSelectedSpeakerList(undefined)
        setCurrentListRecord(undefined);
        setCurrentCreateRecord(undefined);
        setMemberListToDelete([]);
        setShowError("");
    };

    // const handleCreateListModalClose2 = () => {
    //     setCurrentListRecord(undefined);
    //     setCurrentCreateRecord(undefined);
    // };

    const handleCreateListSave = () => {
        // console.log(
        //     "currentListRecord contactId speakerId",
        //     currentListRecord,
        //     userDetails?.contact,
        //     currentCreateRecord
        // );

        if (currentListRecord.name) {
            if (currentListRecord.id) {
                dispatch(
                    updateSpeakerListAsync({
                        list: {
                            ...currentListRecord,
                            contactId: userDetails?.contact?.id,
                            accountId: userDetails?.contact?.accountId,
                        },
                        speakerId: currentCreateRecord?.Id,
                    })
                );

                if (memberListToDelete.length > 0) {
                    for (let member of memberListToDelete) {
                        dispatch(removeSpeakerFromListAsync({ member: member }));
                    }
                    setMemberListToDelete([]);
                }
            } else {
                dispatch(
                    createSpeakerListAsync({
                        list: {
                            ...currentListRecord,
                            contactId: userDetails?.contact?.id,
                            accountId: userDetails?.contact?.accountId,
                        },
                        speakerId: currentCreateRecord?.Id,
                    })
                );
            }

            setOpenCreateListModal(false);
            setSelectedSpeakerList(undefined);
            setCurrentListRecord(undefined);
            setCurrentCreateRecord(undefined);
            setShowError("");
        } else {
            setShowError("Please enter a list name");
        }
    };

    const handleUpdateListSave = () => {
        if (currentListRecord.name) {
            dispatch(
                updateSpeakerListAsync({
                    list: {
                        ...currentListRecord,
                        contactId: userDetails?.contact?.id,
                    },
                    speakerId: currentCreateRecord?.Id,
                })
            );
            setSelectedSpeakerList(currentListRecord);
            setOpenCreateListModal(false);
            setCurrentListRecord(undefined);
            setCurrentCreateRecord(undefined);
        }
    };

    const handleListDeleteConfirmationAgree = () => {
        dispatch(
            updateSpeakerListAsync({
                list: {
                    ...currentListRecord,
                    contactId: userDetails?.contact?.id,
                    isDeleted: true,
                },
                speakerId: currentCreateRecord?.Id,
            })
        );
        setOpenCreateListModal(false);
        setSelectedSpeakerList(undefined);
        setCurrentListRecord(undefined);
        setCurrentCreateRecord(undefined);
        setOpenListDeleteConfirmationModal(false);
    };

    const handleListDeleteConfirmationOpen = () => {
        setOpenListDeleteConfirmationModal(true);
    };

    const handleListDeleteConfirmationClose = () => {
        setOpenListDeleteConfirmationModal(false);
        // setOpenCreateListModal(false);
        // setSelectedSpeakerList(undefined);
        // setCurrentListRecord(undefined);
        // setCurrentCreateRecord(undefined);
    };
    // const handleDeleteSpeakerList2 = ({ callback }) => {
    //     dispatch(
    //         updateSpeakerListAsync({
    //             list: {
    //                 ...currentListRecord,
    //                 contactId: userDetails?.contact?.id,
    //                 isDeleted: true,
    //             },
    //             speakerId: currentCreateRecord?.Id,
    //         })
    //     );
    //     setSelectedSpeakerList(undefined);
    //     setCurrentListRecord(undefined);
    //     setCurrentCreateRecord(undefined);
    //     callback && callback();
    // };

    const setListName = (name) => {
        setCurrentListRecord({ ...currentListRecord, name: name });
    };
    const handlePrivateChange = (event) => {
        setCurrentListRecord({
            ...currentListRecord,
            type: event.target.checked ? "Private" : "Public",
            isPrivate: event.target.checked,
        });
    };

    const handleFilterChange = (event) => {
        let value = event.detail.value;
        if (value) {
            setFilterCount((currCount) => currCount + 1);
        } else {
            setFilterCount((currCount) => currCount - 1);
        }
    };

    const handleFilterChange2 = (event) => {
        let value = event.detail.value;
        if (value) {
            setFilterCount((currCount) => currCount + 1);
        } else {
            setFilterCount((currCount) => currCount - 1);
        }
    };

    const handleClearFilter = () => {
        setFilterCount(0);
        setAvailabilityCheck("");
        setAvailabilityCheckStart("");
        setAvailabilityCheckEnd("");
    };

    const handleSelectListChange = (event, value) => {
        if (value) {
            setSelectedSpeakerList(data?.speakerLists.find((item) => item.id === value.id));
        } else {
            setSelectedSpeakerList(undefined);
        }
        customClearRefinementsRef.current?.clearFilter();
    };

    const clearMyListFilter = () => {
        customClearRefinementsRef.current?.clearFilter();
        //searchRef.setQuery("").search();
    };

    const handleAddSpeaker = (event) => {
        let speakerRecord = event.detail.value;
        let listId = event.detail.listId;
        dispatch(
            addSpeakerToListAsync({
                listId: listId,
                speakerId: speakerRecord?.Id,
            })
        );
    };

    const handleRemoveFilter = (event) => {
        let speakerRecord = event.detail.value;
        let listId = event.detail.listId;
        let listRecord = data?.speakerLists?.find((item) => item.id === listId);
        let member = listRecord?.members?.find((item) => item.speakerId === speakerRecord?.Id);

        // console.log("member", member);

        if (member) {
            setSelectedMemberToDelete(member);
            setOpenDeleteConfirmationModal(true);
        }
    };

    const handleRemoveSpeakerFromList = (event) => {
        let speakerRecord = event.detail.value;
        let listId = event.detail.listId;
        let member = currentListRecord?.members?.find((item) => item.speakerId === speakerRecord?.Id);

        // console.log("member", member);

        if (member) {
            let members = currentListRecord?.members?.filter((item) => item.speakerId !== speakerRecord?.Id);

            setMemberListToDelete([...memberListToDelete, member]);
            setCurrentListRecord({ ...currentListRecord, members: members });
        }
    };

    const handleRemoveFilter2 = (member) => {
        if (member) {
            setSelectedMemberToDelete(member);
            setOpenDeleteConfirmationModal(true);
        }
    };

    const handleDeleteConfirmationClose = () => {
        setOpenDeleteConfirmationModal(false);
    };

    const handleDeleteConfirmationSave = () => {
        dispatch(removeSpeakerFromListAsync({ member: selectedMemberToDelete }));

        setSelectedMemberToDelete(undefined);
        setOpenDeleteConfirmationModal(false);
    };

    // const handleDeleteConfirmationSave2 = () => {
    //     dispatch(
    //         removeSpeakerFromListAsync({ member: selectedMemberToDelete })
    //     );
    //     setSelectedSpeakerList(data?.speakerLists?.find(item=>item.id===selectedSpeakerList.id))
    //     setSelectedMemberToDelete(undefined);
    //     setOpenDeleteConfirmationModal(false);
    // };

    const handleManageList = () => {
        setOpenCreateListModal(true);
        setCurrentListRecord(selectedSpeakerList);
    };

    // const handleEditList = ({ callback }) => {
    //     setCurrentListRecord(selectedSpeakerList);

    //     callback && callback();
    // };

    const getConfigureFilter = () => {
        let filters = "";
        // if (availabilityCheck) {
        //     const givenDate = new Date(availabilityCheck).getTime();
        //     const startDateFilter = `calendarEntries.startDateTimestanp > ${givenDate}`;
        //     const endDateFilter = `calendarEntries.endDateTimestanp < ${givenDate}`;
        //     filters = `(${startDateFilter} OR ${endDateFilter})`;
        // }
        let statusFilter = [];
        if (isBureau) {
            statusFilter = ["Exclusive", "Co-Exclusive", "Partnership", "Exclusive Partnership"];
        } else {
            statusFilter = [
                "Exclusive",
                "Partnership",
                "Exclusive Partnership",
                "Co-Exclusive",
                "Non-Exclusive, Managed By",
            ];
        }

        filters = 'statusReason:"Active"';

        if (statusFilter?.length > 0) {
            filters =
                filters + (filters ? " AND " : "") + statusFilter.map((item) => `speakerStatus:"${item}"`).join(" OR ");

            if (isBureau) {
                filters = filters + ` OR preferredBureau:"Yes"`;
            }
        }

        if (selectedSpeakerList) {
            filters =
                filters +
                (filters ? " AND " : "") +
                (selectedSpeakerList?.members?.length === 0
                    ? "objectID:blankId"
                    : selectedSpeakerList?.members?.map((item) => `objectID:${item.speakerId}`).join(" OR "));
        }
        return filters;
    };

    const handleLeaveNote = (event) => {
        if (!event.detail.note) {
            let record = event.detail.value;
            setCurrentNote({
                id: "",
                description: "",
                speakerId: record.Id,
                contactId: userDetails?.contact?.id,
            });
        } else {
            setCurrentNote(event.detail.note);
        }
        setOpenLeaveNoteModal(true);
    };

    const handleNoteChange = (value) => {
        setCurrentNote({ ...currentNote, description: value });
    };

    const handleLeaveNoteModalClose = () => {
        setCurrentNote(undefined);
        setOpenLeaveNoteModal(false);
    };

    const handleLeaveNoteSave = () => {
        if (currentNote.description) {
            dispatch(saveNotesAsync({ note: currentNote }));
            setCurrentNote(undefined);
            setOpenLeaveNoteModal(false);
        }
    };

    const handleRequestProposal = () => {
        setOpenRequestProposalModal(true);
    };

    const handleRequestProposalModalClose = () => {
        // selectedSpeakerList.endDate = undefined;
        // selectedSpeakerList.startDate = undefined;
        // selectedSpeakerList.endTime = undefined;
        // selectedSpeakerList.startTime = undefined;
        // selectedSpeakerList.city = undefined;
        // selectedSpeakerList.state = undefined;
        // selectedSpeakerList.country = undefined;
        // selectedSpeakerList.note = undefined;
        // selectedSpeakerList.status = undefined;

        setOpenRequestProposalModal(false);
    };

    const handleRequestProposalSave = () => {
        if (
            selectedSpeakerList?.endDate &&
            selectedSpeakerList?.startDate &&
            selectedSpeakerList?.endTime &&
            selectedSpeakerList?.startTime &&
            selectedSpeakerList?.city &&
            selectedSpeakerList?.state &&
            selectedSpeakerList?.country &&
            selectedSpeakerList?.note
        ) {
            selectedSpeakerList.endDate = format(new Date(selectedSpeakerList.endDate), "yyyy-MM-dd");
            selectedSpeakerList.startDate = format(new Date(selectedSpeakerList.startDate), "yyyy-MM-dd");
            selectedSpeakerList.status = "Requested Proposal";
            dispatch(
                updateSpeakerListAsync({
                    list: {
                        ...selectedSpeakerList,
                        contactId: userDetails?.contact?.id,
                    },
                })
            );
            setOpenRequestProposalModal(false);
        } else {
            const detailEvent = new CustomEvent("openToster", {
                detail: {
                    variant: "error",
                    message: "All fields are required, please fill the details",
                },
            });
            document.dispatchEvent(detailEvent);
            return "";
        }
    };

    const handleValueChange = (value, field) => {
        let data = JSON.parse(JSON.stringify(selectedSpeakerList));
        data[field] = value;
        setSelectedSpeakerList(data);
    };

    const handleRequestClick = () => {
        const createEvent = new CustomEvent("requestProposal");
        document.dispatchEvent(createEvent);
    };

    const toggleDrawer = (open) => (event) => {
        if (event?.type === "keydown" && (event?.key === "Tab" || event?.key === "Shift")) {
            return;
        }

        setFilterDrawerOpen(open);
    };

    const FilterUI = (
        <>
            <Card
                sx={{
                    ...styles.card,
                    minWidth: "unset",
                    mb: "1rem",
                    width: {
                        xs: "100%",
                        sm: "unset",
                    },
                }}>
                <CardHeader
                    sx={{
                        padding: "15px",
                        borderBottom: "1px solid #e7e8f0",
                    }}
                    title={`Search`}
                    action={
                        <IconButton
                            aria-label="close-filters"
                            onClick={toggleDrawer(false)}
                            sx={{
                                display: {
                                    xs: "block",
                                    lg: "none",
                                },
                            }}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
                <CardContent sx={{ pt: "15px", pb: "15px" }}>
                    <SearchBox
                        container={"#name-search-box"}
                        placeholder="Search by name or keyword"
                        searchAsYouType={true}
                        autoFocus={false}
                        showReset={true}
                        onSubmit={isTabletScreen ? toggleDrawer(false) : undefined}
                        classNames={{
                            input: "input-classname",
                        }}
                    />
                </CardContent>
            </Card>
            <Card
                sx={{
                    ...styles.card,
                    minWidth: "unset",
                    width: {
                        xs: "100%",
                        sm: "unset",
                    },
                }}>
                <CardHeader
                    sx={{
                        padding: "15px",
                        borderBottom: "1px solid #e7e8f0",
                    }}
                    title={`Filters`}
                    action={
                        filterCount > 0 && (
                            <>
                                <CustomClearRefinements
                                    ref={customClearRefinementsRef}
                                    filterCount={filterCount}></CustomClearRefinements>
                            </>
                        )
                    }
                />
                <CardContent sx={{ p: 0 }}>
                    <Filter
                        label="Topics & Types"
                        icon={
                            <BusinessCenterIcon
                                fontSize="small"
                                sx={{ color: config.primaryColor }}></BusinessCenterIcon>
                        }>
                        <CustomRefinementList
                            attribute="mainCategory"
                            searchable={true}
                            showMore={true}
                            showMoreLimit={1000}></CustomRefinementList>
                    </Filter>
                    {!isBureau && (
                        <Filter
                            label="Speaker Status"
                            icon={
                                <Brightness7Icon fontSize="small" sx={{ color: config.primaryColor }}></Brightness7Icon>
                            }>
                            <CustomRefinementList
                                attribute="speakerStatus"
                                searchable={true}
                                showMore={true}
                                showMoreLimit={1000}></CustomRefinementList>
                        </Filter>
                    )}
                    {isBureau && (
                        <>
                            {/* <Filter
                                label="Fee Region"
                                icon={
                                    <LocationOnOutlinedIcon
                                        fontSize="small"
                                        sx={{ color: config.primaryColor }}
                                    />
                                }
                            >
                                <CustomRefinementList
                                    attribute="regionFeeName"
                                    searchable={false}
                                    showMore={true}
                                    showMoreLimit={1000}
                                ></CustomRefinementList>
                            </Filter> */}
                            {/* <Filter
                                label="Budget"
                                icon={
                                    <AttachMoneyIcon
                                        fontSize="small"
                                        sx={{ color: config.primaryColor }}
                                    ></AttachMoneyIcon>
                                }
                            >
                                <CustomRefinementList
                                    attribute="regionFeeValue"
                                    searchable={false}
                                    showMore={true}
                                    showMoreLimit={1000}
                                ></CustomRefinementList>
                            </Filter> */}

                            <Filter
                                label="Fee Region"
                                icon={<LocationOnOutlinedIcon fontSize="small" sx={{ color: config.primaryColor }} />}>
                                <CustomMenu
                                    attribute="regionFeeName"
                                    label="Fee Region"
                                    showMore={true}
                                    showMoreLimit={1000}></CustomMenu>
                            </Filter>
                            <Filter
                                label="Budget"
                                icon={
                                    <AttachMoneyIcon
                                        fontSize="small"
                                        sx={{ color: config.primaryColor }}></AttachMoneyIcon>
                                }>
                                <CustomMenu
                                    attribute="regionFeeValue"
                                    label="Budget"
                                    showMore={true}
                                    showMoreLimit={1000}></CustomMenu>
                            </Filter>
                        </>
                    )}
                    {!isBureau && (
                        <>
                            {/* <Filter
                                label="Budget"
                                icon={
                                    <AttachMoneyIcon
                                        fontSize="small"
                                        sx={{ color: config.primaryColor }}
                                    ></AttachMoneyIcon>
                                }
                            >
                                <CustomRefinementList
                                    attribute="feeCode"
                                    searchable={false}
                                    showMore={true}
                                    showMoreLimit={1000}
                                ></CustomRefinementList>
                            </Filter> */}

                            <Filter
                                label="Budget"
                                icon={
                                    <AttachMoneyIcon
                                        fontSize="small"
                                        sx={{ color: config.primaryColor }}></AttachMoneyIcon>
                                }>
                                <CustomMenu
                                    attribute="feeCode"
                                    label="Budget"
                                    showMore={true}
                                    showMoreLimit={1000}></CustomMenu>
                            </Filter>
                        </>
                    )}
                    <Filter
                        label="Event Dates"
                        icon={<DateRangeIcon fontSize="small" sx={{ color: config.primaryColor }}></DateRangeIcon>}>
                        <Box sx={{ "& .MuiFormControl-root": { width: "100%" } }} fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth sx={{ mt: 0 }}>
                                <DatePicker
                                    label="Start Date"
                                    minDate={new Date()}
                                    maxDate={availabilityCheckEnd}
                                    value={availabilityCheckStart ? availabilityCheckStart : null}
                                    onChange={(newValue) => {
                                        if (
                                            newValue &&
                                            availabilityCheckEnd &&
                                            (!availabilityCheckEnd || !availabilityCheckStart)
                                        ) {
                                            handleFilterChange2({
                                                detail: {
                                                    value: newValue,
                                                },
                                            });
                                            setIsEventDateAdded(true);
                                        }
                                        if (!newValue && !availabilityCheckEnd && isEventDateAdded) {
                                            handleFilterChange2({
                                                detail: {
                                                    value: newValue,
                                                },
                                            });
                                            setIsEventDateAdded(false);
                                        }
                                        setAvailabilityCheckStart(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{
                                                "& .MuiIconButton-root": {
                                                    marginRight: "0px",
                                                },
                                            }}
                                            placeholder="Select event date"
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box
                            sx={{
                                mt: "1rem",
                                "& .MuiFormControl-root": { width: "100%" },
                            }}
                            fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth sx={{ mt: 0 }}>
                                <DatePicker
                                    label="End Date"
                                    minDate={availabilityCheckStart ? availabilityCheckStart : new Date()}
                                    maxDate={
                                        availabilityCheckStart
                                            ? new Date(availabilityCheckStart).setDate(
                                                  new Date(availabilityCheckStart).getDate() + 4
                                              )
                                            : new Date().setDate(new Date().getDate() + 4)
                                    }
                                    value={availabilityCheckEnd ? availabilityCheckEnd : null}
                                    onChange={(newValue) => {
                                        if (
                                            newValue &&
                                            availabilityCheckStart &&
                                            (!availabilityCheckEnd || !availabilityCheckStart)
                                        ) {
                                            handleFilterChange2({
                                                detail: {
                                                    value: newValue,
                                                },
                                            });
                                            setIsEventDateAdded(true);
                                        }

                                        if (!newValue && !availabilityCheckStart && isEventDateAdded) {
                                            handleFilterChange2({
                                                detail: {
                                                    value: newValue,
                                                },
                                            });
                                            setIsEventDateAdded(false);
                                        }

                                        setAvailabilityCheckEnd(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{
                                                "& .MuiIconButton-root": {
                                                    marginRight: "0px",
                                                },
                                            }}
                                            placeholder="Select event date"
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Filter>
                    <Filter
                        label="Traveling from"
                        icon={<LocationOnIcon fontSize="small" sx={{ color: config.primaryColor }}></LocationOnIcon>}>
                        <CustomMenu
                            attribute="speakerHomeCountry"
                            label="Country"
                            showMore={true}
                            showMoreLimit={1000}></CustomMenu>
                        <CustomMenu
                            attribute="speakerHomeState"
                            label="State"
                            showMore={true}
                            showMoreLimit={1000}></CustomMenu>
                        <CustomMenu
                            attribute="speakerHomeCity"
                            label="City"
                            showMore={true}
                            showMoreLimit={1000}></CustomMenu>
                    </Filter>
                    {/* <Filter label="WSB Status" icon={<CheckCircleOutlineIcon fontSize='small' sx={{ color: config.primaryColor }}></CheckCircleOutlineIcon>}>
            <CustomRefinementList attribute="speakerStatus" searchable={false} showMore={true} showMoreLimit={1000}></CustomRefinementList>
        </Filter> */}
                </CardContent>
            </Card>
        </>
    );

    const getImageURL = (speaker) => {
        return speaker?.speakerPortalImage ? speaker?.speakerPortalImage : speaker?.speakerImagePublicURL;
    };
    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    let body = (
        <div style={styles.container}>
            <InstantSearch searchClient={searchClient} indexName={process.env.REACT_APP_ALGOLIA_INDEX_NAME}>
                <Configure
                    // restrictSearchableAttributes={["name"]}
                    key={getConfigureFilter()}
                    filters={getConfigureFilter()}
                />
                <Grid container spacing={2} justifyContent="start">
                    <Grid
                        lg={9}
                        xs={12}
                        item
                        sx={{
                            height: `calc(${window.innerHeight}px - 2rem)`,
                            // overflow: "auto",
                        }}>
                        {/* Header Title */}
                        <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={{ xs: "center", sm: "center" }}
                            marginBottom={"1rem"}
                            flexDirection={{
                                xs: "column",
                                sm: "row",
                            }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    width: { xs: "100%", sm: "auto" },
                                    justifyContent: {
                                        xs: "space-between",
                                        md: "start",
                                    },
                                }}>
                                <Typography
                                    color={"#000"}
                                    fontSize={"24px"}
                                    fontWeight={"500"}
                                    lineHeight={"normal"}
                                    marginBottom={{
                                        xs: "1rem",
                                        sm: "0",
                                    }}
                                    display={{ xs: "block", sm: "none" }}>
                                    Speaker Search
                                </Typography>
                                <Typography
                                    color={"#000"}
                                    fontSize={"24px"}
                                    fontWeight={"500"}
                                    lineHeight={"normal"}
                                    marginBottom={{
                                        xs: "1rem",
                                        sm: "0",
                                    }}
                                    display={{ xs: "none", sm: "block" }}>
                                    WSB Speaker Search
                                </Typography>
                                <Stats
                                    selectedSpeakerList={selectedSpeakerList}
                                    clearMyListFilter={clearMyListFilter}
                                    handleRequestClick={handleRequestClick}></Stats>
                            </Box>

                            <Box
                                display={"flex"}
                                width={{
                                    xs: "100%",
                                    sm: "unset",
                                }}
                                justifyContent={{
                                    xs: "space-between",
                                    sm: "unset",
                                }}
                                alignItems={"center"}>
                                <MyList
                                    data={data}
                                    currentListRecord={currentListRecord}
                                    setListName={setListName}
                                    handlePrivateChange={handlePrivateChange}
                                    handleCreateListModalClose={handleCreateListModalClose}
                                    currentCreateRecord={currentCreateRecord}
                                    handleCreateListSave={handleCreateListSave}
                                    setCurrentListRecord={setCurrentListRecord}
                                    setCurrentCreateRecord={setCurrentCreateRecord}
                                    handleEditList={handleEditList}
                                    setSelectedSpeakerList={setSelectedSpeakerList}
                                    selectedSpeakerList={selectedSpeakerList}
                                    handleRemoveFilter2={handleRemoveFilter2}
                                    userDetails={userDetails}
                                    handleCreate={handleCreate}
                                    onFilterSelect={handleSelectListChange}
                                />

                                <IconButton
                                    sx={{
                                        padding: {
                                            xs: "0.5rem 0.625rem",
                                            sm: "0.875rem 0.875rem",
                                        },
                                        borderRadius: "6px",
                                        border: `1px solid #D0D5DD`,
                                        background: "#FFF",
                                        color: "#344054",
                                        marginLeft: "1rem",

                                        display: {
                                            // xs:'inline-flex',
                                            lg: "none",
                                        },
                                    }}
                                    onClick={toggleDrawer(true)}>
                                    <FilterAlt />
                                </IconButton>
                            </Box>
                        </Box>
                        {/* Show all applied filters */}
                        <ShowAppliedFiltersUI setUpperBoxHeight={setUpperBoxHeight} />

                        {/* Show list filters */}
                        <Box ref={upperBoxRef2}>
                            {selectedSpeakerList?.status && (
                                <Card
                                    sx={{
                                        ...styles.card,
                                        mb: "1rem",
                                    }}>
                                    <CardContent sx={{ padding: "10px 15px" }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}>
                                            <Typography
                                                sx={{
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    color: "#000",
                                                }}>
                                                {selectedSpeakerList?.name} ({selectedSpeakerList?.members?.length || 0}
                                                )
                                            </Typography>
                                            <Box>
                                                {selectedSpeakerList?.status === "Requested Proposal" ? (
                                                    <div>
                                                        <Button
                                                            variant="text"
                                                            color="success"
                                                            sx={{
                                                                color: "#5048E5",
                                                            }}
                                                            startIcon={<CheckIcon fontSize="small" />}>
                                                            Proposal requested
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <Button
                                                        disabled={selectedSpeakerList?.members?.length === 0}
                                                        variant="contained"
                                                        onClick={handleRequestClick}>
                                                        Request proposal
                                                    </Button>
                                                )}
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}
                        </Box>
                        {/* Search bar commented */}

                        <Box
                            height={{
                                xs: "unset",
                                sm: `calc(100% - ${
                                    parseInt(upperBoxHeight.h1 || 52) +
                                    parseInt(upperBoxHeight.h2 || 0) +
                                    parseInt(upperBoxHeight.h3 || 0)
                                }px)`,
                            }}>
                            <InfiniteHits
                                speakerLists={data?.speakerLists}
                                listBySpeaker={data?.listBySpeaker}
                                commentBySpeaker={data?.commentBySpeaker}
                                noteBySpeaker={data?.noteBySpeaker}
                                availabilityCheckStart={availabilityCheckStart}
                                availabilityCheckEnd={availabilityCheckEnd}
                                countryPicklist={countryPicklist}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                filter={getConfigureFilter()}
                            />
                        </Box>
                    </Grid>
                    <Grid
                        lg={3}
                        item
                        xs={12}
                        display={{
                            xs: "none",
                            lg: "block",
                        }}
                        sx={{
                            height: `calc(${window.innerHeight}px - 2rem)`,
                            overflowY: "auto",
                        }}>
                        {FilterUI}
                    </Grid>
                </Grid>

                {/* open drawer for filters */}
                <SwipeableDrawer
                    // onOpen={}
                    anchor="right"
                    open={filterDrawerOpen}
                    onClose={toggleDrawer(false)}
                    // onOpen={toggleDrawer(true)}
                    PaperProps={{
                        sx: {
                            // padding: "10px",
                            width: {
                                xs: "100%",
                                sm: "unset",
                            },
                        },
                    }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {FilterUI}
                        </Grid>
                    </Grid>
                </SwipeableDrawer>
            </InstantSearch>

            {/* <Modal
                open={openCreateListModal}
                title="Create list"
                onClose={handleCreateListModalClose}
                onSave={handleCreateListSave}
                maxWidth="md"
                actions={
                    <div style={{ width: "100%" }}>
                        <Grid container justifyContent="space-between" alignContent="center">
                            <Grid item>
                                <Button color="error" onClick={handleDeleteSpeakerList}>
                                    Delete
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button onClick={handleCreateListModalClose}>Cancel</Button>
                                <Button onClick={currentListRecord?.id ? handleUpdateListSave : handleCreateListSave}>
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                }>
                <Box>
                    <TextField
                        value={currentListRecord?.name}
                        onChange={(event) => setListName(event.target.value)}
                        fullWidth
                        id="outlined-basic"
                        label="List name"
                        variant="outlined"
                    />
                    <Box
                        sx={{
                            border: "1px solid #e7e8f0",
                            borderRadius: "8px",
                            mt: "10px",
                        }}>
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: "8px 15px", color: "#a1a1a1" }}>
                            <Grid item>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <VisibilityOffIcon fontSize="small" sx={{ mr: "10px" }}></VisibilityOffIcon>
                                    Make list private?
                                </Box>
                            </Grid>
                            <Grid item>
                                <Switch
                                    checked={currentListRecord?.type === "Private"}
                                    onChange={handlePrivateChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal> */}
            <Modal
                open={openLeaveNoteModal}
                title={currentNote?.id ? "Edit note" : "Leave a note"}
                onClose={handleLeaveNoteModalClose}
                onSave={handleLeaveNoteSave}
                maxWidth="md">
                <Box>
                    <TextField
                        onChange={(event) => handleNoteChange(event.target.value)}
                        fullWidth
                        value={currentNote?.description}
                        label="Enter notes for the speaker"
                        variant="outlined"
                        multiline
                        rows={6}
                        maxRows={6}
                    />
                </Box>
            </Modal>
            <AlertDialog
                title="Confirm"
                message="Are you sure, you want to remove this speaker for the list?"
                open={openDeleteConfirmationModal}
                onDisagree={handleDeleteConfirmationClose}
                onAgree={handleDeleteConfirmationSave}></AlertDialog>

            <Modal
                // open={openRequestProposalModal}
                open={false} //not using
                title={"Request proposal"}
                onClose={handleRequestProposalModalClose}
                onSave={handleRequestProposalSave}
                maxWidth="sm">
                <Box>
                    <Grid sx={{ mt: "10px" }} container spacing={1}>
                        <Grid item xs={12}>
                            <Typography>
                                Please provide as much detail about your event as possible. It will help us provide you
                                the most accurate information about the requested speakers. Someone from our team will
                                reach out soon with a proposal.
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start date"
                                    value={selectedSpeakerList?.startDate}
                                    onChange={(newValue) => handleValueChange(newValue, "startDate")}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <FormControl fullWidth>
                                <InputLabel id="start-time-label">Start time</InputLabel>
                                <Select
                                    labelId="start-time-label"
                                    id="start-time-select"
                                    label="Start time"
                                    value={selectedSpeakerList?.startTime}
                                    onChange={(event) => handleValueChange(event.target.value, "startTime")}>
                                    {startDateTimePicklist.map((item) => (
                                        <MenuItem key={item.id} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid sx={{ mt: "10px" }} container spacing={1}>
                        <Grid xs={12} sm={6} item>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End date"
                                    value={selectedSpeakerList?.endDate}
                                    onChange={(newValue) => handleValueChange(newValue, "endDate")}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <FormControl fullWidth>
                                <InputLabel id="end-time-label">End time</InputLabel>
                                <Select
                                    labelId="end-time-label"
                                    id="end-time-select"
                                    label="End time"
                                    value={selectedSpeakerList?.endTime}
                                    onChange={(event) => handleValueChange(event.target.value, "endTime")}>
                                    {endDateTimePicklist.map((item) => (
                                        <MenuItem key={item.id} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid sx={{ mt: "10px" }} container spacing={1}>
                        <Grid xs={12} sm={6} item>
                            <TextField
                                onChange={(event) => handleValueChange(event.target.value, "city")}
                                fullWidth
                                value={selectedSpeakerList?.city}
                                label="Venue City"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <TextField
                                onChange={(event) => handleValueChange(event.target.value, "state")}
                                fullWidth
                                value={selectedSpeakerList?.state}
                                label="Venue State"
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: "10px" }}>
                        <FormControl fullWidth>
                            <InputLabel id="country-label">Venue Country</InputLabel>
                            <Select
                                labelId="country-label"
                                id="country-select"
                                label="Venue Country"
                                value={selectedSpeakerList?.country}
                                onChange={(event) => handleValueChange(event.target.value, "country")}>
                                {countryPicklist.map((item) => (
                                    <MenuItem value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ mt: "10px" }}>
                        <TextField
                            onChange={(event) => handleValueChange(event.target.value, "note")}
                            fullWidth
                            value={selectedSpeakerList?.note}
                            label="Event Information"
                            placeholder="Please share any additional additional details about your event, including the audience or any other relevant information."
                            variant="outlined"
                            multiline
                            rows={3}
                            maxRows={5}
                        />
                    </Box>
                </Box>
            </Modal>

            {/* Create/Edit List Open Modal  */}
            <Modal2
                open={openCreateListModal}
                SubmitButtonText={currentListRecord?.id ? "Save List" : "Create List"}
                hideHeading={true}
                contentSx={{
                    padding: "1rem 0",
                }}
                onModalSubmit={handleCreateListSave}
                showDeleteButton={currentListRecord?.id ? true : false}
                onDelete={handleListDeleteConfirmationOpen}
                onClose={() => {
                    // current modal
                    handleCreateListModalClose();
                }}>
                <Typography
                    sx={{
                        color: "#101828",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "144.444%", // Equivalent to 26px
                        marginBottom: "0.5rem",
                    }}>
                    {currentListRecord?.id ? "Edit list" : "Create new list"}
                </Typography>
                <TextField
                    fullWidth
                    label="List name"
                    variant="outlined"
                    value={currentListRecord?.name}
                    onChange={(event) => {
                        if (showError) {
                            setShowError("");
                        }

                        setListName(event.target.value);
                    }}
                    error={showError}
                    helperText={showError}
                />
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    //  check box border color
                                    color: "#444CE7",
                                }}
                                checked={currentListRecord?.type === "Private"}
                                onChange={handlePrivateChange}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        }
                        label={"Make list private"}
                    />
                    {currentListRecord?.members?.length > 0 && (
                        <Box marginTop={"1.5rem"}>
                            <Typography fontSize={"1rem"} fontWeight={600} color={"#101828"} lineHeight={"150%"}>
                                Saved Speakers
                            </Typography>

                            <List
                                sx={{
                                    width: "100%",
                                    bgcolor: "background.paper",
                                    borderTop: "1px solid rgba(0,0,0,0.06)",
                                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                                    marginTop: "0.875rem",
                                    overflow: "scroll",
                                    maxHeight: "50vh",
                                }}>
                                {currentListRecord?.members?.map((item) => {
                                    const labelId = `checkbox-list-secondary-label-${item}`;
                                    return (
                                        <ListItem
                                            key={item}
                                            secondaryAction={
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        ...styles.outlinedButton,

                                                        "@media (max-width:375px)": {
                                                            padding: {
                                                                xs: "4px 6px",
                                                                sm: "4px 12px",
                                                            },
                                                            minWidth: "unset",
                                                        },
                                                    }}
                                                    onClick={() =>
                                                        handleRemoveSpeakerFromList({
                                                            detail: {
                                                                value: {
                                                                    Id: item.speakerId,
                                                                },
                                                                listId: currentListRecord.id,
                                                            },
                                                        })
                                                    } //record,listId
                                                >
                                                    <DeleteOutlineIcon
                                                        sx={{
                                                            color: config.primaryColor,
                                                            fontSize: "20px",
                                                            display: "none",

                                                            "@media (max-width:375px)": {
                                                                display: "inline",
                                                            },
                                                        }}></DeleteOutlineIcon>
                                                    <Box
                                                        component={"span"}
                                                        sx={{
                                                            "@media (max-width:375px)": {
                                                                display: "none",
                                                            },
                                                        }}>
                                                        Remove
                                                    </Box>
                                                </Button>
                                            }
                                            disablePadding>
                                            <ListItemButton>
                                                <ListItemAvatar>
                                                    <Avatar alt={`Avatar n°${item + 1}`} src={getImageURL(item)} />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    id={labelId}
                                                    primary={`${item.speakerName}`}
                                                    secondary={item.name}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Box>
                    )}
                </Box>
            </Modal2>

            {/* request proposal 2 */}
            <Modal2
                open={openRequestProposalModal}
                hideHeading
                onClose={handleRequestProposalModalClose}
                onModalSubmit={handleRequestProposalSave}
                headingIcon={<ProposalIcon />}>
                <Box>
                    <Grid sx={{ mt: "10px" }} container spacing={2}>
                        <Grid item xs={12}>
                            <Typography
                                fontSize={"1.125rem"}
                                fontWeight={600}
                                color={"#101828"}
                                lineHeight={"144.444%"}>
                                Request Proposal
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontSize={"0.875rem"}>
                                Please provide as much detail about your event as possible. It will help us provide you
                                the most accurate information about the requested speakers. Someone from our team will
                                reach out soon with a proposal.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid sx={{ mt: "1.5rem" }} container spacing={2}>
                        <Grid xs={12} sm={6} item>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start date"
                                    value={selectedSpeakerList?.startDate}
                                    onChange={(newValue) => handleValueChange(newValue, "startDate")}
                                    renderInput={(params) => <TextField {...params} fullWidth color="primary" />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <FormControl fullWidth>
                                <InputLabel id="start-time-label">Start time</InputLabel>
                                <Select
                                    labelId="start-time-label"
                                    id="start-time-select"
                                    label="Start time"
                                    value={selectedSpeakerList?.startTime}
                                    onChange={(event) => handleValueChange(event.target.value, "startTime")}>
                                    {startDateTimePicklist.map((item) => (
                                        <MenuItem value={item.value}>{item.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid sx={{ mt: "10px" }} container spacing={2}>
                        <Grid xs={12} sm={6} item>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End date"
                                    value={selectedSpeakerList?.endDate}
                                    onChange={(newValue) => handleValueChange(newValue, "endDate")}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <FormControl fullWidth>
                                <InputLabel id="end-time-label">End time</InputLabel>
                                <Select
                                    labelId="end-time-label"
                                    id="end-time-select"
                                    label="End time"
                                    value={selectedSpeakerList?.endTime}
                                    onChange={(event) => handleValueChange(event.target.value, "endTime")}>
                                    {endDateTimePicklist.map((item) => (
                                        <MenuItem value={item.value}>{item.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid sx={{ mt: "10px" }} container spacing={2}>
                        <Grid xs={12} sm={6} item>
                            <TextField
                                onChange={(event) => handleValueChange(event.target.value, "city")}
                                fullWidth
                                value={selectedSpeakerList?.city}
                                label="Venue City"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <TextField
                                onChange={(event) => handleValueChange(event.target.value, "state")}
                                fullWidth
                                value={selectedSpeakerList?.state}
                                label="Venue State"
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>

                    <Grid sx={{ mt: "10px" }} container spacing={2}>
                        <Grid xs={12} item>
                            <FormControl fullWidth>
                                <InputLabel id="country-label">Venue Country</InputLabel>
                                <Select
                                    labelId="country-label"
                                    id="country-select"
                                    label="Venue Country"
                                    value={selectedSpeakerList?.country}
                                    onChange={(event) => handleValueChange(event.target.value, "country")}>
                                    {countryPicklist.map((item) => (
                                        <MenuItem value={item.value}>{item.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={12} item>
                            <TextField
                                onChange={(event) => handleValueChange(event.target.value, "note")}
                                fullWidth
                                value={selectedSpeakerList?.note}
                                label="Event Information"
                                placeholder="Please share any additional additional details about your event, including the audience or any other relevant information."
                                variant="outlined"
                                multiline
                                rows={3}
                                maxRows={5}
                            />
                        </Grid>
                    </Grid>

                    <Divider
                        sx={{
                            borderColor: "rgba(0,0,0,0.06)",
                            marginTop: "1.5rem",
                        }}
                    />
                </Box>
            </Modal2>

            <Drawer anchor="right" open={openSpeakerScreen}>
                <Speaker
                    defaultSpeakerDetail
                    width="700px"
                    userDetails={userDetails}
                    speakerId={selectedSpeakerForViewProfile?.id}
                    record={selectedSpeakerForViewProfile}
                    disableTracking></Speaker>
            </Drawer>
            {openListDeleteConfirmationModal && (
                <AlertDialog
                    title="Confirm"
                    message="Are you sure, you want to remove this record for the list?"
                    open={openListDeleteConfirmationModal}
                    onDisagree={handleListDeleteConfirmationClose}
                    onAgree={handleListDeleteConfirmationAgree}></AlertDialog>
            )}
        </div>
    );

    return getPageContent(body, status, error);
};

export { SpeakerSearch };
